import axios from 'axios';
import { APIResponse, LoginAuth } from './AuthClasses';
import moment from 'moment';

const ROOT_URL = process.env.REACT_APP_API_URL+'/auth'
const DEBUG = process.env.REACT_APP_DEBUG=='1';
export const CDN_URL = process.env.REACT_APP_CDN_URL;

async function post<T=any>(endpoint: string, data?: any) : Promise<APIResponse<T>>{
	var options = {
		headers: {
			'Content-Type': 'application/json'
		}
	}
	if(data instanceof FormData){
		options.headers['Content-Type'] = 'multipart/form-data';
	}

	try{
		var ENDPOINT = `${ROOT_URL}/${endpoint}`;
		if(DEBUG) console.log("POST "+ENDPOINT);
		var res = await axios.post(ENDPOINT, data, options);
		if(DEBUG) console.log(` => Response: ${(res.headers['content-length']/1024).toFixed(2)} KB`);
		return res.data as APIResponse<T>;
	}catch(err){
		if(DEBUG) console.error(err);
		return {
			error: true, 
			message: 'Hubo un error inesperado (APIP-LCL-1)',
			code: 'APIP-LCL-1',
		}
	}
};

var login = async (email: string, password: string, remember: boolean)=>{
	try{
		var res = await post<LoginAuth>('login', { email, password, remember });
		if(res.error || res.data?.password_change) return res;
	}catch(e){
		throw e;
	}

	if(remember){
		try{
			localStorage.setItem('auth', JSON.stringify(res.data));
		}catch(e){
			throw e;
		}
	}
	return res;
}

var logout = ()=>{
	localStorage.removeItem('auth');
}

var getActiveLogin = ()=>{
	var auth_s = localStorage.getItem('auth');
	if(!auth_s) return null;

	try{
		var auth = JSON.parse(auth_s) as LoginAuth;
		if(!auth) return null;

		if(!auth.tokens) return null;
		var now = moment().unix();
		if(auth.tokens.refresh_expires<now) return null;

		return auth;
	}catch(e){
		throw e;
	}
}

var refreshLogin = async (token: string)=>{
	try{
		var res = await post<LoginAuth>('refresh', { token });
		if(res.error || res.data?.password_change) return res;
	}catch(e){
		throw e;
	}

	try{
		localStorage.setItem('auth', JSON.stringify(res.data));
	}catch(e){
		throw e;
	}

	return res;
}

export default {
	CDN_URL,
	getActiveLogin,
	login,
	logout,
	refreshLogin,
}